import { TFunction } from 'react-i18next';
import { Property } from 'csstype';
import { SummaryTableRows } from '@chargify/custom-ui-components';
import { Currency, formatCurrency } from '@chargify/formatters';
import { AllocationDetails } from '../../../machines/addOnsConfiguration/types';

type Params = {
  componentsAllocations: AllocationDetails[];
  t: TFunction<'subscriptions-manager'[]>;
  language: string;
  currency: Currency;
};

export const mapAllocationsToTable = ({
  componentsAllocations,
  t,
  language,
  currency,
}: Params) => {
  const parsedAllocations = [] as SummaryTableRows;

  componentsAllocations.map((allocation) => {
    const nameColumn = {
      value: allocation?.name,
    };

    let allocationDescription = '';

    if (allocation.type === 'on_off') {
      if (allocation.previousQuantity === 0 && allocation.quantity === 1) {
        allocationDescription = t('components_allocations.turn_on');
      } else if (
        allocation.previousQuantity === 1 &&
        allocation.quantity === 0
      ) {
        allocationDescription = t('components_allocations.turn_off');
      } else {
        allocationDescription = t('components_allocations.no_change');
      }
    }

    if (allocation.type === 'quantity') {
      allocationDescription = t('components_allocations.from_to', {
        fromValue: allocation.previousQuantity,
        toValue: allocation.quantity + ' ' + allocation.unitName,
      });
    }

    allocationDescription = `(${allocationDescription})`;
    if (allocation.memo) {
      allocationDescription += '\n"' + allocation.memo + '"';
    }

    const descriptionColumn = {
      value: allocationDescription,
      color: 'gray.dark',
    };

    const priceColumn = {
      value: formatCurrency(currency, allocation.amountInCents, language),
      textAlign: 'right' as Property.TextAlign,
      color: allocation.amountInCents === 0 ? 'gray.main' : 'black.main',
    };

    const allocationRow = [nameColumn, descriptionColumn, priceColumn];
    parsedAllocations.push(allocationRow);
  });

  return parsedAllocations;
};
